import { helpers } from '@kurtosys/ksys-app-template';
import { ConditionalDataConfig } from '../../models/configuration/ConditionalDataConfig';

export default function getConditionalDataFlag(
    valuesForValidation: {},
    config: ConditionalDataConfig
) {
    if (config && config.conditional) {
        const conditionalHelper = new helpers.ConditionalHelper(
            config.conditional
        );
        return conditionalHelper.matches(valuesForValidation);
    }
    return false;
}



// WEBPACK FOOTER //
// ./src/utils/query/getConditionalDataFlag.ts